import { usePaginationState } from '../pagination/usePaginationState'
import { useAPIRequest } from '~/composables/api/useAPIRequest'

export async function useNewsListingData(options: {
  paginationState: ReturnType<typeof usePaginationState>
  route: ReturnType<typeof useRoute>
}) {
  let postsUrl = '/articles/filter/section_id/1'

  if (options.route.params.tag_id) {
    postsUrl = `/articles/filter/tag_id/${options.route.params.tag_id}`
  }

  return await useAPIRequest(postsUrl, {
    params: {
      page: options.paginationState.state.currentPage.value,
      limit: options.paginationState.state.pageSize,
    },
  })
}
